"use client";

import type { ReactNode } from "react";

import Image from "next/image";

import type { RhfGroupWithProducts } from "@/src/domain/model/RhfGroup";

import { RhfModal } from "@/src/app/ou-trouver-les-produits/RhfModal";
import { HoverTooltip } from "@/src/components/ui/HoverTooltip";
import { useModal } from "@/src/components/ui/Modal/ModalProvider";

interface RhfProps {
  readonly groups: RhfGroupWithProducts[];
}

export function Rhf({ groups }: RhfProps): ReactNode {
  const { setModal } = useModal();
  return (
    <>
      {groups.map((group) => (
        <HoverTooltip content={group.name} key={group.id}>
          <button
            className="rounded-full bg-white p-2"
            onClick={() => {
              setModal(<RhfModal group={group} />);
            }}
          >
            <Image
              alt={group.name}
              className="cursor-pointer"
              height={36}
              src={group.image.url}
              width={36}
            />
          </button>
        </HoverTooltip>
      ))}
    </>
  );
}
